import { useState } from "react";
import { Link } from "react-router-dom";
import LogoTray from "../LogoTray";
import "../../Search.css";
import "./Auth.css";
import { validateEmail } from "../../utils/emailPolicy";

// Define API URL as a constant
const API_URL = process.env.REACT_APP_API_URL || "/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    const emailPolicyError = validateEmail(email);
    if (emailPolicyError) {
      setError(emailPolicyError);
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/forgot-password`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message || "Email za resetovanje lozinke je poslan!");
      } else {
        setError(data.error || data.message || "Greška pri slanju emaila za resetovanje lozinke.");
      }
    } catch (err) {
      console.error('Forgot password error:', err);
      if (err.name === 'TypeError' && err.message === 'Failed to fetch') {
        setError("Nije moguće povezati se sa serverom. Molimo provjerite svoju internetsku vezu i pokušajte ponovo.");
      } else {
        setError("Došlo je do neočekivane greške. Molimo pokušajte ponovo.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LogoTray />
      <div className="auth-container">
        <div className="auth-box">
        <div className="tech-border">
          <div className="auth-content">
            <h2 className="text-center mb-4">Zaboravili ste lozinku?</h2>
            {message && <div className="alert alert-success text-center">{message}</div>}
            {error && <div className="alert alert-danger text-center">{error}</div>}
            
            <form onSubmit={handleSubmit} noValidate>
              <div className="form-group mb-4">
                <label>Email adresa</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="form-control tech-input"
                  placeholder="Unesite vašu email adresu"
                />
              </div>
              <button 
                type="submit" 
                className="btn btn-primary w-100 tech-button"
                disabled={loading}
              >
                {loading ? "Slanje..." : "Pošalji link za resetovanje"}
              </button>
            </form>
            
            <div className="text-center mt-4">
              <p className="mb-2">Sjetili ste se lozinke?</p>
              <Link to="/login" className="tech-link">
                Vratite se na prijavu
              </Link>
            </div>

            <div className="text-center mt-3">
              <p className="mb-2">Nemate račun?</p>
              <Link to="/signup" className="tech-link">
                Registrujte se ovdje
              </Link>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
